import { render } from "./ServiceInfoForm.vue?vue&type=template&id=6688d08a&scoped=true"
import script from "./ServiceInfoForm.vue?vue&type=script&lang=js"
export * from "./ServiceInfoForm.vue?vue&type=script&lang=js"

import "./ServiceInfoForm.vue?vue&type=style&index=0&id=6688d08a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6688d08a"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
